
import { useEffect, useState } from "react";
import { AxiosOnlineCheckerInstance } from "../utils";
export default function () {

    const [isBrowserOnline, setIsBrowserOnline] = useState<Boolean>(true)

    useEffect(()=> {
        const callbackId = AxiosOnlineCheckerInstance.bindCallbacks(()=> {
            setIsBrowserOnline(true)
        }, ()=> {
            setIsBrowserOnline(false)
        })

        window.addEventListener('offline', ()=> {
            AxiosOnlineCheckerInstance.start(5000)
        })
                                
        return () => {
            AxiosOnlineCheckerInstance.removeCallbacks(callbackId)
            window.removeEventListener('offline', ()=> {
                AxiosOnlineCheckerInstance.start(5000)
            })
        }
    },[])

    return { isBrowserOnline }
}
